import $ from 'jquery';
import borderTemplate from 'properties/style/border.ejs';
import borderColorTemplate from 'properties/style/border-color.ejs';
import { pickerCfg } from 'pickerCfg';
import BasePropertyView from 'BasePropertyView'
import themeService     from 'ThemeService';
import TextUtil from 'util/TextUtil';
import constants    from 'Constants.js';

class StyleBorderView extends BasePropertyView {

    initialize( opts ) {
        super.initialize(opts);
        this.options = opts || {};
        this.template = borderTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        if (this.model.get('factoryKey') === 'control_progress_bar' ||
            this.model.get('factoryKey') === 'control_captcha' ||
            this.model.get('factoryKey') === 'control_checkbox' ||
            this.model.get('factoryKey') === 'control_radio_button' ) {
            this.template = borderColorTemplate;
        }

        // Note:  #cornerRadius is handled on autocompleteselect function
        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change #borderColor' : 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes',
            'keydown input.custom-combobox-input': 'validatePositiveNumericNotPeriod'
        };

        return this;
    }

    validatePositiveNumericNotPeriod(ev){
        TextUtil.validatePositiveNumericNotPeriod(ev);
    }

    updateAttributes(ev, columnModel = undefined, name=undefined, value= undefined) {
        const propName = ev.currentTarget.name,
              oldValue = this.model.get(propName);

        super.updateAttributes(ev, columnModel, name, value);
        if ( this.isThemeProperty(oldValue) ){
            themeService.deattachTheme(this);
        }

    }

    render() {
        this.model.set('hideColor', ( this.model.get('hideColor') || '' ), constants.MODEL_SILENT);
        this.model.set('hideRadius', ( this.model.get('hideRadius') || '' ), constants.MODEL_SILENT);
        super.render();

        let props = this.model.toJSON();
        props.borderColor = themeService.resolve(props.borderColor);
        props.cornerRadius = this.resolveThemeBorderProperty('cornerRadius');
        props.borderSize = this.resolveThemeBorderProperty('borderSize');
        props.borderStyle = this.resolveThemeBorderProperty('borderStyle');
        this.$el.html(this.template(props));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        //set selected index to model value
        this.prepareComboWidget(this.$el);

        $("#cornerRadius", this.$el).combobox({
            value: props.cornerRadius,
            change: (e, param) => {
                this.model.set('cornerRadius', param.value);
            }
        });
        this.updateForm();
        this.delegateEvents();
        this.updateCombobox();


        return this;
    }

    updateForm() {
        //set selected index to model value
        if(this.model.get('cornerRadius')) {
            $('#cornerRadius').find('option[value="' +
                this.resolveThemeBorderProperty('cornerRadius') +'"]').attr('selected', true);
        }
    }

    updateCombobox(){
        if(this.model.get('buttonStyle') === 'rectangular'){
            $("#cornerRadius").parent().find("input.ui-autocomplete-input").autocomplete("option", "disabled", true).prop("disabled",true);
            $("#cornerRadius").parent().find("a.ui-button").button("disable");
        }
        else{
            $("#cornerRadius").parent().find("input.ui-autocomplete-input").autocomplete("option", "disabled", false).prop("disabled",false);
            $("#cornerRadius").parent().find("a.ui-button").button("enable");
        }
    }

    prepareComboWidget($el) {
        let selfThis = this;
        $.widget("custom.combobox", {
            _create: function () {
                this.wrapper = $("<span>")
                    .addClass("custom-combobox")
                    .insertAfter(this.element);

                this.element.hide();
                this._createAutocomplete(this.options);
                this._createShowAllButton();
            },

            _createAutocomplete: function (options) {
                var selected = this.element.children(":selected");

                this.input = $("<input>", {
                    maxLength: 3
                })
                    .appendTo(this.wrapper)
                    .addClass("custom-combobox-input ui-widget ui-widget-content ui-corner-left")
                    .val(options.value)
                    .autocomplete({
                        classes: {
                            "ui-autocomplete": "custom-autocomplete"
                        },
                        delay: 0,
                        minLength: 0,
                        source: $.proxy(this, "_source"),
                        appendTo: $el,
                        search: options.value
                    });

                this._on(this.input, {
                    input: function (e, param) {
                        var value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');

                        this.input.val(value);
                        this.element.val(value);
                        this.input.autocomplete("disable");
                    }, //PF-2105 - Forms/Reports - Font size (general)
                    change: function (e, param) {
                        let name = event.currentTarget.parentElement.parentElement.children[0].name;
                        let value = e.currentTarget.value.replace(/[^[0-9]+(\.[0-9]{1,2})?$]/g, '');
                        this._trigger("change", null, {value: value});
                        this._trigger("select", e, {item: value});
                        selfThis.updateAttributes(e, null, name, value);
                    },
                    autocompleteselect: function (event, ui) {
                        let name = event.currentTarget.parentElement.parentElement.children[0].name;
                        let value =  ui.item.value;
                        ui.item.option.selected = true;
                        this._trigger("change", null, {value: ui.item.value});
                        this._trigger("select", event, {item: ui.item.option});
                        selfThis.updateAttributes(event, null, name, value);
                    }
                });
            },

            _createShowAllButton: function () {
                var input = this.input,
                    element = this.element,
                    wasOpen = false;

                $("<a>")
                    .attr("tabIndex", -1)
                    .appendTo(this.wrapper)
                    .button({
                        icons: {
                            primary: "ui-icon-triangle-1-s"
                        },
                        text: false
                    })
                    .removeClass("ui-corner-all")
                    .addClass("custom-combobox-toggle ui-corner-right")
                    .on("mousedown", function () {
                        wasOpen = input.autocomplete("widget").is(":visible");
                    })
                    .on("click", function () {
                        input.trigger("focus");

                        // Close if already visible
                        if (wasOpen) {
                            return;
                        }
                        // Pass empty string as value to search for, displaying all results
                        input.autocomplete("search", "20");
                    });
            },

            _source: function (request, response) {
                response(this.element.children("option").map(function () {
                    var text = $(this).text();
                    return {
                        label: text,
                        value: text,
                        option: this
                    };
                }));
            },

            _destroy: function () {
                this.wrapper.remove();
                this.element.show();
            }
        });
    }

}

export default StyleBorderView;